import type { QuickPrompt } from '@coursera-web/wes-common';

import _t from 'i18n!nls/teams-v2';

export const getTeamsCoachQuickPrompts = (): QuickPrompt[] => [
  {
    key: 'wes-funnel-whats-included',
    prompt: _t('What’s included in the Team plan?'),
  },
  {
    key: 'wes-funnel-billing-info',
    prompt: _t('Can I add licenses later?'),
  },
  {
    key: 'wes-funnel-change-licenses',
    prompt: _t('Do you offer invoice payment?'),
  },
];

export const getTeamsCheckoutRotatingQuestions = (): string[] => [
  _t('What payment methods can I use?'),
  _t('Can I get an invoice, quote, or receipt?'),
  _t('Can I add more licenses later?'),
];
